// extracted by mini-css-extract-plugin
module.exports = {"textarea":"gdlTextarea_textarea_2W9lG"};